import { generatePath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';
import { generateLogoBuilderURL } from '#client/utils/urls';

import { processMenu } from '../utils/menu';

/**
 * Get the Web Tools menu items.
 *
 * @param {{
 *  businessEntityUuid: string
 * }} params
 * @returns {Array}
 */
export function getWebToolsMenuItems({
  businessEntityUuid,
  isGoogleBusinessProfilePhase2Released
}) {
  const logoBuilderNavigationProps = (() => ({
    target: '_blank',
    url: generateLogoBuilderURL(businessEntityUuid)
  }))();

  const emailNavigationProps = (() => ({
    title: 'Email',
    path: generatePath(ROUTES.entityMarketingTools, { businessEntityUuid, '*': 'emails' })
  }))();

  const domainNavigationProps = (() => ({
    title: 'Domain Names',
    path: generatePath(ROUTES.entityMarketingTools, { businessEntityUuid, '*': 'domains' })
  }))();

  const gbpNavigationProps = (() => ({
    title: 'Google Profile',
    path: generatePath(ROUTES.entityMarketingTools, { businessEntityUuid, '*': 'business-marketing-profile' })
  }))();

  const webToolsMenuItems = [
    {
      order: 10,
      title: 'Overview',
      itemId: 'growth_overview',
      path: generatePath(ROUTES.entityMarketingTools, { businessEntityUuid })
    },
    {
      order: 20,
      title: 'Website',
      itemId: 'growth_website',
      path: generatePath(ROUTES.entityWebsites, { businessEntityUuid })
    },
    {
      ...domainNavigationProps,
      itemId: 'growth_domain_names',
      order: 30
    },
    {
      ...emailNavigationProps,
      itemId: 'growth_email',
      order: 40
    },
    {
      ...logoBuilderNavigationProps,
      order: 50,
      title: 'Logo',
      itemId: 'growth_logo',
      newItem: true
    }
  ];

  if (isGoogleBusinessProfilePhase2Released) {
    webToolsMenuItems.push({
      ...gbpNavigationProps,
      itemId: 'growth_google_profile',
      order: 60,
      newItem: true
    });
  }

  return webToolsMenuItems;
}

/**
 * Get the web tools menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: Set<string>
 *  ldFlags: object
 *  order?: number
 *  isMobile: boolean
 * }} params
 * @returns {object}
 */
export function getWebToolsMenu(params) {
  const { businessEntityUuid, ldFlags, order } = params;
  const { isGoogleBusinessProfilePhase2Released, releaseWebToolsSingleLeftNavMenuItem } = ldFlags;
  const menuData = releaseWebToolsSingleLeftNavMenuItem
    ? {
      itemId: 'growth_overview',
      path: generatePath(ROUTES.marketingTools, { businessEntityUuid })
    }
    : {
      itemId: 'growth',
      links: getWebToolsMenuItems({
        ...params,
        isGoogleBusinessProfilePhase2Released
      })
    };

  return processMenu({
    title: 'Web Tools',
    icon: 'webpage-fill.svg',
    order,
    ...menuData
  });
}
